import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from '../RegionNoteForm.css';
import { resizeModal } from '../../../../actions/modalActions';
import { ModalMode, ModalSize } from '../../../../types';

type Mode = string;
type IncorrectFileFormat = boolean;

type RegionNoteFormFooterProps = {
  modalMode: Mode;
  isLoading: boolean;
  confirmTitleKey: string;
  setDeleteConfirmationModal: (boolean) => void;
  handleCloseConfirmationClick: () => void,
  onSaveButtonClick: () => void,
  incorrectFileFormat: IncorrectFileFormat;
  isNewComment: boolean;
};

export const RegionNoteFormFooter = ({
  modalMode,
  isLoading,
  confirmTitleKey,
  setDeleteConfirmationModal,
  handleCloseConfirmationClick,
  onSaveButtonClick,
  incorrectFileFormat,
  isNewComment
}: RegionNoteFormFooterProps) => {
  const dispatch = useDispatch();

  return (
    <div className={styles.regionNoteModalFooter}>
      <div>
        <Button
          className={styles.deleteButton}
          data-test-id="region-note-form-delete"
          disabled={modalMode === ModalMode.ADD_REGION || isNewComment}
          isLoading={isLoading}
          mode="secondary"
          onClick={() => {
            dispatch(resizeModal(ModalSize.S));
            setDeleteConfirmationModal(true);
          }}
        >
          {getMessage(confirmTitleKey)}
        </Button>
      </div>
      <div>
        <Button
          className={styles.cancelRegionNoteButton}
          data-test-id="region-note-form-cancel"
          isLoading={isLoading}
          mode="secondary"
          onClick={handleCloseConfirmationClick}
        >
          {getMessage('cancel')}
        </Button>
        <Button
          className={styles.saveRegionNoteButton}
          data-test-id="region-note-form-submit"
          disabled={incorrectFileFormat}
          isLoading={isLoading}
          mode="primary"
          onClick={onSaveButtonClick}
        >
          {getMessage('regions.report.modal.saveReport')}
        </Button>
      </div>
    </div>
  );
};
